export default __webpack_public_path__ + "static/media/redmi2.0587b2b2.jpg";